import React, { useEffect, useRef, useState } from 'react';
import styled, { cutDates, inputStyles, stockNumber, inputNumbersmall, inputStyle11 } from '../../Utils/inputChanges';
import {
    TextField, FormControl, InputLabel, Grid, Paper,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer, Typography,
    TableRow, Autocomplete, TextareaAutosize, Checkbox,
    RadioGroup, FormControlLabel, Radio,
    CircularProgress,

} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import TitleBar from '../TitleBar';
import { PackingMenu } from '../TitleList';
import { selectFirm, selectlocationdata, selectParty, selectSchool, selectTransports } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchPartyData, fetchSingleParty } from '../../Store/PHPSlice/Party';
import { fetchLocationData, fetchTransportData } from '../../Store/PHPSlice/Transport';
import DateInputComponent from '../FieldsComponents/DateInputComponent';
import Dropdown from '../FieldsComponents/Dropdown';
import TextareaComponent from '../FieldsComponents/TextareaComponent';
import { fetchSchoolData } from '../../Store/PHPSlice/School';
import { fetchPackingSlipMemo, fetchStkOnlyManualbarcode, fetchStkOrderManualbarcode, insertPackingEntry } from '../../Store/PHPSlice/Packing/PackApis';
import { selectPackingSlipMemo, selectStkOnlyManualnos, selectStkOrderManualnos } from '../Selectors/PackSelector/PackingSelector';
import axios from 'axios';
import RadioComponent from '../FieldsComponents/RadioComponent';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';


const PackingEntry = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        dt: getCurrentDate(),
        barcode: '',
        eType: '1',
        pkMemo: '',
        baleNo: '',
        firm: '',
        party: '',
        adrs: '',
        trspt: '',
        shtoNm: '',
        shtoadrs: '',
        parcelqty: '',
        remark: '',
        item: '',
        schlNm: '',
        totQty: '',
        ordMan: '',
        soId: '',
        types: '1',
        scanBar: '',
        locId: '',
        glocId: '',
        ordtypes: 'Sale Order',
        totqty: '',
        totamt: '',
        freight_ch: '0',
        other_ch: '0',
        grandtot: '',
        gst_type: 'no',
        gst: 5,
        igst: '0',
        cgst: '0',
        sgst: '0',
        state_type: '',
        discnt_type: 'percent',
        discnt_amt: '',
        discnt_val: '0',
        netamt: '',
        userId: userdata?.ID
    });
    const debounceTimeout = useRef(null);
    const [packData, setPackData] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [saleordlist, setSaleordlist] = useState([]);
    const [soItemlist, setSoItemlist] = useState([]);
    const [selectedParty, setSelectedParty] = useState([]);

    const [locGarment, setLocGarment] = useState([]);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectParty);
    const transportlist = useSelector(selectTransports);
    const schlist = useSelector(selectSchool);

    const stkOrdManualnos = useSelector(selectStkOrderManualnos);
    const stkOnlyManualnos = useSelector(selectStkOnlyManualnos);
    const packMemo = useSelector(selectPackingSlipMemo);
    const locdata = useSelector(selectlocationdata);
    const baseUrl = process.env.REACT_APP_BASE_URL;

    const [openDropdowns, setOpenDropdowns] = useState({});


    const actionMap = {
        party: fetchPartyData
        // Add more mappings if needed
    };

    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchPartyData());
        dispatch(fetchTransportData());
        dispatch(fetchSchoolData());
        dispatch(fetchStkOrderManualbarcode());
        // dispatch(fetchStkOnlyManualbarcode());
        dispatch(fetchPackingSlipMemo());
        dispatch(fetchLocationData());
        fetchSaleorderDefault();
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    useEffect(() => {
        if (packMemo?.data && packMemo.data?.pkMemo) {
            const Id = packMemo.data.pkMemo;
            setFormData(prev => ({
                ...prev,
                pkMemo: Id
            }));
        }
    }, [packMemo]);

    useEffect(() => {
        if (selectedParty?.length > 0) {
            const data = selectedParty[0]
            setFormData(prev => ({
                ...prev,
                adrs: data?.adrs
            }));
        }
    }, [selectedParty]);

    const isDesktop = useMediaQuery('(min-width:768px)');
    const handleDateChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    const toNum = (v) => {
        const n = parseFloat(v);
        return Number.isFinite(n) ? n : 0;
    };

    const recalcTotals = (override = {}) => {
        // take latest values (override has priority)
        const totamt = toNum(override.totamt ?? formData.totamt);
        const discnt_val = toNum(override.discnt_val ?? formData.discnt_val);

        const freight_ch = toNum(override.freight_ch ?? formData.freight_ch);
        const other_ch = toNum(override.other_ch ?? formData.other_ch);

        const gst_type = override.gst_type ?? formData.gst_type; // 'yes'/'no'
        const gstPercent = toNum(override.gst ?? formData.gst);  // GST %
        const state_type = override.state_type ?? formData.state_type; // '1' IGST, '0' CGST/SGST

        // base calculations
        const discAmt = Math.round(totamt * discnt_val / 100);
        const base = Math.round(totamt - discAmt);

        const final_grand = Math.round(base + freight_ch + other_ch);

        // default GST fields
        let igst = 0, cgst = 0, sgst = 0;
        let netamt = final_grand;

        if (gst_type === "yes" && gstPercent > 0) {
            const gst_cal = Math.round(final_grand * gstPercent / 100);

            if (state_type == "1") {
                igst = gst_cal;
            } else {
                cgst = Math.round(gst_cal / 2);
                sgst = Math.round(gst_cal / 2);
            }

            netamt = final_grand + gst_cal;
        }

        setFormData((prev) => ({
            ...prev,
            // keep inputs updated if passed in override
            ...override,
            grandtot: final_grand,
            igst,
            cgst,
            sgst,
            netamt,
        }));
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });

        if (name === 'scanBar') {
            // Clear the previous debounce timer
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }

            // Set a new debounce timer
            debounceTimeout.current = setTimeout(() => {
                if (value) {
                    const data12 = {
                        scanBar: value,
                        type: formData.eType
                    };
                    fetchBarcodeData(data12);

                    // Optionally clear the scanBar field after call
                    setFormData(prevFormData => ({
                        ...prevFormData,
                        scanBar: ''
                    }));
                }
            }, 1000); // delay in milliseconds
        }


        switch (name) {
            case 'discnt_val':
                if (value) {
                    let totalAmount = parseFloat(formData.totamt);
                    let discnt_amt, grandtot;
                    let other_ch = formData.other_ch !== '' ? parseFloat(formData.other_ch) : 0;
                    let freight_ch = formData.freight_ch !== '' ? parseFloat(formData.freight_ch) : 0;
                    if (formData.discnt_type == 'percent') {

                        discnt_amt = Math.round((parseFloat(value) / 100) * totalAmount) || 0;
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    } else if (formData.discnt_type == 'rupees') {
                        discnt_amt = parseFloat(value) || 0;
                        grandtot = totalAmount - discnt_amt + other_ch + freight_ch;
                    }

                    let igst = 0, cgst = 0, sgst = 0;
                    let cal_grand = Math.round(parseFloat(grandtot) * parseFloat(formData.gst) / 100);
                    if (formData.state_type == '1') {
                        igst = cal_grand;
                    } else {
                        const half_grand = (cal_grand / 2).toFixed(2);
                        cgst = half_grand;
                        sgst = half_grand;
                    }
                    let final_grand_tot = Math.round(parseInt(grandtot, 10) + parseInt(cal_grand, 10));
                    setFormData(prev => ({
                        ...prev,
                        discnt_amt: discnt_amt,
                        grandtot: grandtot,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: final_grand_tot
                    }));
                }
                break;
            case 'freight_ch':
                const freight = toNum(value);
                recalcTotals({ freight_ch: freight });
                break;
            case 'other_ch':
                const other = toNum(value);
                recalcTotals({ other_ch: other });
                break;
            default:
                break;
        }
    };

    const handleDropdownChange = async (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });

        switch (dropdownType) {
            case 'ordMan':
                if (value) {
                    setFormData(prev => ({
                        ...prev,
                        ordMan: '' // Reset to clear the field
                    }));
                    if (formData.glocId !== '') {
                        fetchSktSingleRecords(value, formData.glocId);
                    } else {
                        fetchSktSingleRecords(value);
                    }
                    setSelectedItems(prev => [...prev, value]);
                }
                break;
            case 'firm':
                if (value && formData.party !== '') {
                    const data = {
                        firmId: value,
                        partyId: formData.party
                    };
                    fetchPartyWiseSaleOrder(data);
                } else {
                    setSaleordlist([]);
                }
                break;
            case 'party':
                if (value && formData.firm !== '') {
                    const data = {
                        firmId: formData.firm,
                        partyId: value
                    };
                    fetchSelectParty(value);
                    if (saleordlist.length > 0) {
                        setSaleordlist([]);
                        fetchPartyWiseSaleOrder(data);
                    }
                } else {
                    setSaleordlist([]);
                }
                break;
            case 'soId':
                if (value) {
                    fetchSOItems(value);
                    const selectsolist = saleordlist?.find(i => i.ID === value);
                    if (selectsolist) {
                        setFormData(prev => ({
                            ...prev,
                            firm: selectsolist?.firmId,
                            party: selectsolist?.partyId
                        }));
                        fetchStkRecordsSOId(selectsolist?.ID)
                    } else {
                        setPackData([]);
                    }


                } else {
                    setSoItemlist([]);
                    setFormData(prev => ({
                        ...prev,
                        firm: '',
                        party: ''
                    }));
                    setPackData([]);
                }
                break;
            case 'glocId':
                if (value) {
                    fetchLocWiseGarments(value);
                } else {
                    setLocGarment([]);
                }
                break;
            case 'ordtypes':
                if (value) {
                    if (formData.prev_ordtypes === '') {
                        setFormData(prev => ({
                            ...prev,
                            prev_ordtypes: value
                        }));
                    } else {
                        const prev_ordtype = formData.prev_ordtypes !== 'Sale Order';

                        if (prev_ordtype && packData.length > 0 && value === 'Sale Order') {
                            setFormData(prev => ({
                                ...prev,
                                firm: '',
                                party: '',
                                schlNm: '',
                                trspt: '',

                            }));
                            setPackData([]);
                        } else {
                            setFormData(prev => ({
                                ...prev,
                                prev_ordtypes: value
                            }));
                        }
                    }
                }
                break;

            default:
                break;
        }
    };

    const handleQuantityChange = (index, name, value) => {
        // Make a copy of packData
        const updatedPackData = [...packData];

        // Ensure the value is a valid number
        const newValue = parseFloat(value) || 0;

        // Update either rate or qty based on the input field
        if (name === "rate") {
            updatedPackData[index].rate = newValue;
        } else if (name === "qty") {
            // If entered qty is greater than stkqty, set qty to stkqty
            const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
            if (newValue > stkqty) {
                // updatedPackData[index].qty = stkqty; // Set qty to stkqty if the entered value exceeds stkqty
                alert(`Quantity cannot exceed available stock (${stkqty}).`);
            } else {
                updatedPackData[index].qty = newValue; // Otherwise, set qty to entered value
            }
        }


        // Recalculate totalqty (total = rate * qty)
        const qty = updatedPackData[index].qty || 0;  // Ensure qty is a number
        const rate = updatedPackData[index].rate || 0;  // Ensure rate is a number
        updatedPackData[index].totalqty = qty * rate;

        // Handle balqty logic based on stkqty and qty
        const stkqty = updatedPackData[index].stkqty || 0; // Ensure stkqty is a number
        let balqty = 0;
        if (qty > stkqty) {
            // If entered qty is more than stkqty, set balqty to stkqty
            balqty = stkqty;
        } else {
            // Otherwise, set balqty to stkqty - qty
            balqty = stkqty - qty;
        }

        updatedPackData[index].balqty = balqty;

        const totalQty = updatedPackData.reduce((sum, item) => sum + parseFloat(item.qty || 0), 0);
        const totamt = updatedPackData.reduce((sum, item) => sum + parseFloat(item.totalqty || 0), 0);
        const discnt_amt = parseFloat(formData.discnt_val) > 0 ? Math.round(parseFloat(totamt) / parseFloat(formData.discnt_val)) : 0;
        let grandtot = parseFloat(totamt) - discnt_amt;
        // Update state
        setPackData(updatedPackData);

        if (formData.gst_type === 'yes') {
            const update_gross = totamt - discnt_amt + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);

            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = update_gross > 0 ? Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100) : 0;
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross > 0 ? update_gross : 0,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot > 0 ? final_grand_tot : 0
            }));
        }



        setFormData(prev => ({
            ...prev,
            totQty: totalQty,
            totamt: totamt,
            discnt_amt: discnt_amt,
            grandtot: grandtot
        }));
    };

    const handleSelectChange = (index) => {
        // Toggle selection for the row at the given index
        setSelectedRows((prevSelectedRows) => {
            if (prevSelectedRows.includes(index)) {
                // If already selected, remove it from the array
                return prevSelectedRows.filter(item => item !== index);
            } else {
                // Otherwise, add it to the array
                return [...prevSelectedRows, index];
            }
        });
    };

    const handleDelete = () => {
        // Step 1: Remove selected items from packData
        setPackData((prevPackData) => {
            const newPackData = prevPackData.filter((item, index) => !selectedRows.includes(index));

            // Step 2: Remove the corresponding items from selectedItems
            setSelectedItems((prevSelectedItems) => {
                // Find the IDs of the items to be removed (those in selectedRows)
                const itemsToRemove = selectedRows
                    .map(index => prevPackData[index]?.ID) // Get the IDs of the items in selectedRows
                    .filter(id => id !== undefined); // Filter out undefined values (in case the index is invalid)

                // Remove these IDs from selectedItems
                return prevSelectedItems.filter(id => !itemsToRemove.includes(id));
            });

            return newPackData;
        });

        // Step 3: Clear selected rows after deletion
        setSelectedRows([]);

        const updatedPackData = [...packData];
        const totalQty = updatedPackData.reduce((sum, item) => sum + (item.qty || 0), 0);
        const totamt = updatedPackData.reduce((sum, item) => sum + (item.totalqty || 0), 0);
        const discnt_amt = parseFloat(formData.discnt_val) > 0 ? Math.round(parseFloat(totamt) / parseFloat(formData.discnt_val)) : 0;
        let grandtot = parseFloat(totamt) - discnt_amt;
        setFormData(prev => ({
            ...prev,
            totQty: totalQty,
            totamt: totamt,
            discnt_amt: discnt_amt,
            grandtot: grandtot
        }));
    };

    const handleRadioChange = (event) => {
        setFormData({
            ...formData,
            [event.target.name]: event.target.value,
        });
        if (event.target.name === 'eType') {
            setPackData([]);
            setFormData(prev => ({
                ...prev,
                barcode: '',
                baleNo: '',
                firm: '',
                party: '',
                adrs: '',
                trspt: '',
                shtoNm: '',
                shtoadrs: '',
                parcelqty: '',
                remark: '',
                item: '',
                schlNm: '',
                totQty: '',
                ordMan: '',
                soId: '',
                scanBar: '',
                locId: '',
            }));
        }

        if (event.target.value === 'yes') {
            const update_gross = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);

            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = update_gross > 0 ? Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100) : 0;
            if (formData.state_type == '1') {
                igst = cal_grand;
            } else {
                const half_grand = (cal_grand / 2).toFixed(2);
                cgst = half_grand;
                sgst = half_grand;
            }
            let final_grand_tot = Math.round(parseInt(update_gross, 10) + parseInt(cal_grand, 10));

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross > 0 ? update_gross : 0,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot > 0 ? final_grand_tot : 0
            }));

        }
        if (event.target.value === 'no') {
            const gross_tot = parseInt(formData.totamt, 10) - parseInt(formData.discnt_amt, 10);
            const update_gross = parseInt(gross_tot, 10) + parseInt(formData.freight_ch, 10) + parseInt(formData.other_ch, 10);
            let igst = 0, cgst = 0, sgst = 0;
            let cal_grand = update_gross > 0 ? Math.round(parseFloat(update_gross) * parseFloat(formData.gst) / 100) : 0;
            if (formData.state_type == '1') {
                igst = 0;
            } else {
                cgst = 0;
                sgst = 0;
            }
            let final_grand_tot = 0;

            setFormData(prevFormData => ({
                ...prevFormData,
                grandtot: update_gross > 0 ? update_gross : 0,
                igst: igst || 0,
                cgst: cgst || 0,
                sgst: sgst || 0,
                netamt: final_grand_tot > 0 ? final_grand_tot : 0
            }));
        }
    };

    const handleSearch = async (e) => {
        const { value } = e.target;
        setSearch(value);

        if (value.length < 2) {
            setLocGarment([]);
            return;
        }

        try {
            const res = await axios.get(
                `${baseUrl}?apicall=getStockManualnosOnly&search=${value}&locNm=${formData.glocId}`
            );

            setLocGarment(res.data.data || []);

        } catch (err) {
            console.error(err);
        }
    };

    const fetchLocWiseGarments = async (id) => {
        try {
            const res = await axios.get(`${baseUrl}?apicall=getStockManualnosOnly&locNm=${id}`);
            setLocGarment(res?.data?.data);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchStkRecordsSOId = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStockdatausingSOId&soId=${id}`);
            let itemData = response.data.data;
            setPackData(itemData);
        } catch (error) {
            console.error('Error fetching title list:', error);
            setPackData([]);
        }
    };

    const fetchSktSingleRecords = async (id, locNm) => {
        try {
            const endpoint = locNm ? `getStkDataSingleRecord&stkId=${id}&locNm=${locNm}` : `getStkDataSingleRecord&stkId=${id}`;
            const response = await axios.get(`${baseUrl}?apicall=${endpoint}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(`${baseUrl}?apicall=${endpoint}`)
            itemData = {
                ...itemData,
                balqty: itemData.stkqty || 0,  // balqty is the same as stkqty, or 0 if undefined
                qty: 0,  // default value for qty
                totalqty: 0,  // default value for total
                rate: 0  // default value for rate
            };
            // setPackData(prev => Array.isArray(prev) ? [...prev, itemData] : [itemData]);
            setPackData(prev => {
                const prevData = Array.isArray(prev) ? prev : [];

                const alreadyExists = prevData.some(
                    item => item.ID === itemData.ID || item.barcode === itemData.barcode
                );

                if (alreadyExists) {
                    alert("This item already exists in the list.");
                    return prevData;
                }

                return [...prevData, itemData];
            });
        } catch (error) {
            console.error('Error fetching title list:', error);
            setPackData([]);
        }
    };

    const fetchSelectParty = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getPartylist&partyId=${id}`);
            const data = response.data.data;
            // Add new keys with the specified values
            // console.log(data)

            if (data) {
                const item = data[0];
                setFormData(prev => ({
                    ...prev,
                    state_type: item?.state_type
                }));
            }
            setSelectedParty(data);
        } catch (error) {
            console.error('Error fetching title list:', error);
            setSelectedParty([]);
        }
    };


    const fetchPartyWiseSaleOrder = async (id) => {
        const { firmId, partyId } = id;
        try {
            const response = await axios.get(`${baseUrl}?apicall=getSaleOrderFirmParty&firmId=${firmId}&partyId=${partyId}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSaleordlist(itemData);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const fetchSaleorderDefault = async () => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getstocksaleorder`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSaleordlist(itemData);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const fetchSOItems = async (id) => {
        try {
            const response = await axios.get(`${baseUrl}?apicall=getStkProdWithSO&soId=${id}`);
            let itemData = response.data.data;
            // Add new keys with the specified values
            // console.log(itemData)
            setSoItemlist(itemData);

        } catch (error) {
            console.error('Error fetching title list:', error);

        }
    };

    const fetchBarcodeData = async (id) => {
        const { scanBar, type } = id;

        try {
            const response = await axios.get(`${baseUrl}?apicall=getScanBarcode&scanBar=${scanBar}`);
            let itemData = response.data.data;

            if (!itemData) {
                alert('Stock Not Available');
                return;
            }

            const items = itemData;

            const updatedData = [...packData];
            let added = false;
            let alreadyExists = false;

            const exists = updatedData.find(item => item.ID === items.ID);

            if (!exists) {
                updatedData.push({
                    ...items,
                    balqty: items.stkqty || 0,
                    qty: 0,
                    totalqty: 0,
                    rate: 0
                });
                added = true;
            } else {
                alreadyExists = true;
            }

            // Now update the state
            setPackData(updatedData);

            if (alreadyExists) {
                alert('Item already exists');

            }

        } catch (error) {
            console.error('Error fetching barcode data:', error);
        }
    };

    const fields = [
        { label: 'Date', name: 'dt', type: 'date' },
        { label: 'DC Memo', name: 'pkMemo', type: 'readOnly' }
    ];


    const handlePartyNew = () => {
        window.open(`/NewPartyEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownlistfirst = [
        {
            label: 'Firm',
            id: 'firm',
            options: firmlist?.data,
            value: formData.firm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm'),
            getOptionLabel: (option) => option.firmNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Party',
            id: 'party',
            options: partylist?.data,
            value: formData.party,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party'),
            getOptionLabel: (option) => option.partyNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handlePartyNew(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('party'),
            handleDropdownClose: () => handleDropdownClose('party'),
        }
    ];

    const dropdownlistsecond = [
        {
            label: 'School',
            id: 'schlNm',
            options: schlist?.data,
            value: formData.schlNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlNm', value: newValue ? newValue.ID : '' } }, 'schlNm'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Transport',
            id: 'trspt',
            options: transportlist?.data,
            value: formData.trspt,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'trspt', value: newValue ? newValue.ID : '' } }, 'trspt'),
            getOptionLabel: (option) => option.transportNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownShifting = [
        {
            label: 'School',
            id: 'schlNm',
            options: schlist?.data || [],
            value: formData.schlNm,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlNm', value: newValue ? newValue.ID : '' } }, 'schlNm'),
            getOptionLabel: (option) => option.schoolNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        },
        {
            label: 'Location',
            id: 'locId',
            options: locdata?.data || [],
            value: formData.locId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'locId', value: newValue ? newValue.ID : '' } }, 'locId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const filterSelectedItems = (options) => {
        return options.filter(option => !selectedItems.includes(option.ID));
    };
    // console.log(soItemlist);

    const ItemConfig = {
        // 'Sale Order': {
        //     label: 'Item',
        //     id: 'ordMan',
        //     // options: formData.soId !== '' ? filterSelectedItems(soItemlist) : filterSelectedItems(stkOrdManualnos?.data) || [],
        //     options: filterSelectedItems(soItemlist) || [],
        //     value: formData.ordMan || '',
        //     onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
        //     getOptionLabel: (option) => option.order_no || '',
        //     isOptionEqualToValue: (option, value) => option.ID === value.ID,
        //     valueFinder: (options, value) => {
        //         if (Array.isArray(options)) {
        //             return options.find(item => item.ID === value) || null;
        //         }
        //         return null;
        //     },
        // },
        'Garment': {
            label: 'Item',
            id: 'ordMan',
            // options: filterSelectedItems(stkOnlyManualnos?.data) || [],
            options: filterSelectedItems(locGarment) || [],
            value: formData.ordMan || null,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            onSearch: handleSearch
        },
        'Manual Production': {
            label: 'Item',
            id: 'ordMan',
            options: filterSelectedItems(stkOrdManualnos?.data) || [],
            value: formData.ordMan || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            getOptionLabel: (option) => option.order_no || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    };

    const itemConfig2 = {
        'Garment': {
            label: 'Item',
            options: filterSelectedItems(locGarment),
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            onSearch: handleSearch
        },
        'Manual Production': {
            label: 'Item',
            options: filterSelectedItems(stkOrdManualnos?.data),
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordMan', value: newValue ? newValue.ID : '' } }, 'ordMan'),
            onSearch: handleSearch
        }
    }

    const saleConfig = {
        '1': {
            label: 'Sale Order',
            id: 'soId',
            options: saleordlist || [],
            value: formData.soId || '',
            onChange: (newValue) => handleDropdownChange({ target: { name: 'soId', value: newValue ? newValue.ID : '' } }, 'soId'),
            getOptionLabel: (option) => option.sono || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }

    };

    const dropdownlistthird = ItemConfig[formData.ordtypes];

    const dropdownlistthird2 = itemConfig2[formData.ordtypes];
    const saleOrdfourth = saleConfig[formData.eType];
    console.log(locGarment)
    const adrss = [
        // { label: 'Address', name: 'adrs' },
        // { label: 'Ship To Name', name: 'shtoNm' },
        { label: 'Ship To Address', name: 'shtoadrs' },
    ];

    const fieldsecond = [
        { label: 'Parcel Qty', name: 'parcelqty' },
        { label: 'Remark', name: 'remark' },
        { label: 'Total Qty', name: 'totQty', type: 'readOnly' }
    ];

    const options = [
        { value: '1', label: 'Order + Manual' },
        { value: '2', label: 'Manual' },
        // { value: '3', label: 'Shifting' }
    ];

    const typesOptions = [
        { value: '1', label: 'Manual' },
        { value: '2', label: 'Barcode' },
    ];

    const scanBarcode = [
        { label: 'Barcode', name: 'scanBar' },
    ];

    const orderTypes = [
        { label: 'Sale Order', ID: 'Sale Order' },
        { label: 'Manual Production', ID: 'Manual Production' },
        { label: 'Garment', ID: 'Garment' }
    ];

    const orderTypes2 = [
        { label: 'Manual Production', ID: 'Manual Production' },
        { label: 'Garment', ID: 'Garment' }
    ];

    const dropdownOrdTypes = [
        {
            label: 'Order Types',
            id: 'ordtypes',
            options: formData.eType === '2' ? orderTypes2 : orderTypes || [],
            value: formData.ordtypes,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'ordtypes', value: newValue ? newValue.ID : '' } }, 'ordtypes'),
            getOptionLabel: (option) => option.label || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
        }
    ];

    const dropdownGarmentLocation = [
        {
            label: 'Location',
            id: 'glocId',
            options: locdata?.data || [],
            value: formData.glocId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'glocId', value: newValue ? newValue.locNm : '' } }, 'glocId'),
            getOptionLabel: (option) => option.locNm || '',
            isOptionEqualToValue: (option, value) => option.locNm === value.locNm,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.locNm === value) || null;
                }
                return null;
            },
        }
    ];



    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };

    function object(formData, packData) {
        const locNm = locdata?.data?.find(item => item.ID === formData.locId)?.locNm;
        const netamt = formData.netamt !== '' ? formData.netamt : formData.grandtot;
        const discnt_type = formData.discnt_type === 'percent' ? '%' : 'Rs';
        // const discnt_type = formData.discnt_type;
        const gst_type = formData.gst_type === 'yes' ? '1' : '0';
        const data = {
            dt: formData.dt,
            eType: formData.eType,
            pkMemo: formData.pkMemo,
            firmId: formData.firm,
            partyId: formData.party,
            adrs: formData.adrs,
            trnsptId: formData.trspt,
            schlId: formData.schlNm,
            shipNm: formData.shtoNm,
            ship_adrs: formData.shtoadrs,
            parcelqty: formData.parcelqty,
            remark: formData.remark,
            totqty: formData.totQty,
            totamt: formData.totamt,
            state_type: formData.state_type,
            discnt_type: discnt_type,
            discnt_val: formData.discnt_val,
            discnt_amt: formData.discnt_amt,
            freight_ch: formData.freight_ch,
            other_ch: formData.other_ch,
            gst_type: gst_type,
            gst_val: formData.gst,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            net_amt: netamt,
            userId: formData.userId,
            locNm: locNm === " " ? '-' : locNm,
            locId: formData.locId,
            soId: formData.soId,
            packData: packData
        };
        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // const validationErrors = validate();
        // if (Object.keys(validationErrors).length > 0) {
        //     setErrors(validationErrors);
        //     return;
        // }

        setLoading(true);

        try {
            const finalObject = object(formData, packData);
            // console.log(finalObject);
            const result = await dispatch(insertPackingEntry(finalObject)).unwrap();
            console.log('POST request successful!', result);
            // alert("Records Inserted");
            const data = result;
            if (data?.status === "success") {
                alert(data.msg);
                window.location.reload();
            } else {
                if (Array.isArray(data?.msg)) {
                    alert(data.msg.join("\n"));
                } else if (typeof data?.msg === "string") {
                    alert(data.msg);
                }
            }
            // window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }
    };

    const gstField = [
        { label: 'GST(%)', name: 'gst' },
    ];
    const options_gst = [
        { value: 'yes', label: 'Yes' },
        { value: 'no', label: 'No' },
    ];

    const opts_discnt_amt = [
        { value: 'percent', label: '%' },
        { value: 'rupees', label: 'Rs.' },
    ];

    const fields2 = [
        { label: 'Total Amount', name: 'totamt', type: 'readOnly' },
        { label: 'Freight Charges', name: 'freight_ch' },
    ];

    const fields21 = [
        { label: 'Printing Charges', name: 'other_ch' },
        { label: 'Gross Total', name: 'grandtot', type: 'readOnly' }
    ];

    const fields4 = [
        { label: 'IGST', name: 'igst', type: 'readOnly' },
        { label: 'CGST', name: 'cgst', type: 'readOnly' },
        { label: 'SGST', name: 'sgst', type: 'readOnly' },
        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
    ];

    const gstpercentageOptions = [
        { label: '5', val: 5 },
        { label: '12', val: 12 },
        { label: '18', val: 18 },
    ];

    const dropdownGST = [
        {
            label: 'GST(%)',
            id: 'gst',
            options: gstpercentageOptions,

            // store gst as number or string in formData, both ok
            value: formData.gst ?? 5, // default 5

            onChange: (newValue) => {
                // newValue can be object OR string (if freeSolo)
                const gstValue =
                    typeof newValue === "string"
                        ? Number(newValue)
                        : Number(newValue?.val);

                handleDropdownChange(
                    { target: { name: "gst", value: gstValue || 5 } },
                    "gst"
                );

                // call your gst calculation with number
                calculateGstAndNet(gstValue || 5);
            },

            getOptionLabel: (option) =>
                typeof option === "string" ? option : option?.label ?? "",

            isOptionEqualToValue: (option, value) => {
                // value might be object OR number (because you store number in formData)
                if (typeof value === "number") return option?.val === value;
                return option?.val === value?.val;
            },

            valueFinder: (options, value) => {
                // convert stored number (5) to option object
                const v = Number(value);
                return options?.find((o) => o.val === v) || null;
            },
        },
    ];

    const calculateGstAndNet = (gstPercent) => {
        const total_amt = parseInt(formData.totamt || 0, 10);

        const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val || 0) / 100);
        const grandtot2 = Math.round(
            total_amt - gst_amt +
            parseFloat(formData.other_ch || 0) +
            parseFloat(formData.freight_ch || 0)
        );

        let igst = 0, cgst = 0, sgst = 0, netamt = 0;

        if (formData.state_type == '1') {
            igst = Math.round(grandtot2 * gstPercent / 100);
            netamt = igst + grandtot2;
        } else {
            const diff = Math.round(grandtot2 * gstPercent / 100);
            cgst = diff / 2;
            sgst = diff / 2;
            cgst = cgst.toFixed(2);
            sgst = sgst.toFixed(2);
            netamt = diff + grandtot2;
        }

        setFormData(prev => ({
            ...prev,
            igst,
            cgst,
            sgst,
            netamt
        }));
    };


    const handleInputComplete = (e) => {
        const { name, value } = e.target;

        switch (name) {
            case 'gst':
                if (value) {
                    const total_amt = parseInt(formData.totamt, 10);
                    const gst_amt = Math.round(total_amt * parseFloat(formData.discnt_val) / 100);
                    const grandtot2 = Math.round(total_amt - gst_amt + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch));

                    let igst = 0, cgst = 0, sgst = 0, netamt = 0;
                    if (formData.state_type == '1') {
                        igst = Math.round(grandtot2 * parseFloat(value) / 100);
                        netamt = igst + grandtot2;
                    } else if (formData.state_type == '0') {
                        const diff = Math.round(grandtot2 * parseFloat(value) / 100);
                        cgst = Math.round(diff / 2);
                        sgst = Math.round(diff / 2);
                        netamt = diff + grandtot2;
                    }

                    setFormData(prev => ({
                        ...prev,
                        igst: igst || 0,
                        cgst: cgst || 0,
                        sgst: sgst || 0,
                        netamt: netamt
                    }));
                }
                break;

            case 'freight_ch':
                const freight = toNum(value);
                recalcTotals({ freight_ch: freight });
                break;
            case 'other_ch':
                const other = toNum(value);
                recalcTotals({ other_ch: other });
                break;

        }
    };


    return (
        <>
            <TitleBar data={PackingMenu} />
            <div style={{ margin: '1% 0.5%' }}>
                <div style={{ display: 'flex', gap: '5vh' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>

                        <h2 style={{ margin: 0 }}>Delivery Challan Entry</h2>

                        <RadioComponent
                            name="eType"
                            value={formData.eType}
                            options={options}
                            onChange={handleRadioChange}
                            isDesktop={true}
                        />

                        {formData.ordtypes === 'Sale Order' && saleOrdfourth && (
                            <div style={{ minWidth: '550px' }}>
                                <Dropdown
                                    key={saleOrdfourth.label}
                                    label={saleOrdfourth.label}
                                    id={saleOrdfourth.id}
                                    options={saleOrdfourth.options}
                                    value={saleOrdfourth.value}
                                    onChange={saleOrdfourth.onChange}
                                    isDesktop={isDesktop}
                                    getOptionLabel={saleOrdfourth.getOptionLabel}
                                    isOptionEqualToValue={saleOrdfourth.isOptionEqualToValue}
                                    valueFinder={saleOrdfourth.valueFinder}
                                />
                            </div>
                        )}

                    </div>

                </div>


                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '2vh' }}>
                            <Grid container spacing={0.5}>

                                {fields?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    formData.eType !== '3' && dropdownlistfirst && dropdownlistfirst?.map((drop) => (
                                        <DropdownWithBtn
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                            handleAddNew={drop.handleAddNew}
                                            btnlabel={drop.btnlabel}
                                            handleDropdownOpen={drop.handleDropdownOpen}
                                            handleDropdownClose={drop.handleDropdownClose}
                                        />
                                    ))
                                }

                                {formData.eType !== '3' && adrss?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    formData.eType !== '3' && dropdownlistsecond && dropdownlistsecond?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }


                                {
                                    formData.eType === '3' && dropdownShifting && dropdownShifting?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }



                                {fieldsecond?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {/* <TextareaComponent
                                    label="Naration"
                                    name="nartn"
                                    value={formData.nartn}
                                    onChange={handleInputChange}
                                    isDesktop={isDesktop}
                                /> */}

                                {dropdownOrdTypes?.map((drop) => (
                                    <Dropdown
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                    />
                                ))}

                                <RadioComponent
                                    label="Item Type:"
                                    name="types"
                                    value={formData.types}
                                    options={typesOptions}
                                    onChange={handleRadioChange}
                                    isDesktop={true} // Pass the actual value based on screen size
                                />

                                {
                                    formData.ordtypes === 'Garment' &&
                                    dropdownGarmentLocation?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        />
                                    ))
                                }

                                {/* {
                                    formData.types === '1' && dropdownlistthird &&
                                    <Dropdown
                                        key={dropdownlistthird.label}
                                        label={dropdownlistthird.label}
                                        id={dropdownlistthird.id}
                                        options={dropdownlistthird.options}
                                        value={dropdownlistthird.value}
                                        onChange={dropdownlistthird.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={dropdownlistthird.getOptionLabel}
                                        isOptionEqualToValue={dropdownlistthird.isOptionEqualToValue}
                                        valueFinder={dropdownlistthird.valueFinder}  // Pass `valueFinder` function here
                                        onSearch={dropdownlistthird?.onSearch}
                                    />
                                } */}

                                {
                                    formData.types === '1' && dropdownlistthird2 &&
                                    <div>
                                        <label htmlFor="search-dropdown">{dropdownlistthird2.label}:</label>
                                        <br />
                                        <input
                                            id="search-dropdown"
                                            type="text"
                                            placeholder="Type to search..."
                                            value={search}
                                            onChange={dropdownlistthird2.onSearch}
                                            style={{ width: '300px', padding: '4px' }}
                                        />
                                        <br />
                                        <select value={formData.ordMan}
                                            style={{ width: '300px', padding: '4px' }}
                                            onChange={(e) =>
                                                handleDropdownChange(
                                                    { target: { name: 'ordMan', value: e.target.value } },
                                                    'ordMan'
                                                )
                                            }
                                        >
                                            <option value="">
                                                Select an option
                                            </option>
                                            {dropdownlistthird2.options?.map((option, index) => (
                                                <option key={index} value={option.ID}>
                                                    {option.order_no}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                }

                                {formData.types === '2' && scanBarcode?.map((field) => (
                                    <DateInputComponent
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleDateChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}


                                <Grid item xs={6}>
                                    <Button variant="contained" color="primary" size='small' disabled={selectedRows.length === 0} onClick={handleDelete}>Delete</Button>
                                </Grid>

                                {Array.isArray(packData) && packData.length > 0 &&
                                    <>
                                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                            <Table style={isDesktop ? { width: '70%' } : { width: '100%' }}>
                                                <TableBody>

                                                    <TableRow>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>
                                                            <input
                                                                type="checkbox"
                                                                onChange={() => {
                                                                    // Select all checkboxes when the header checkbox is toggled
                                                                    if (selectedRows.length === packData.length) {
                                                                        setSelectedRows([]); // Deselect all if already selected
                                                                    } else {
                                                                        setSelectedRows(packData.map((_, index) => index)); // Select all
                                                                    }
                                                                }}
                                                                checked={selectedRows.length === packData.length}
                                                            />Select
                                                        </TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Sr.No.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Barcode</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Item</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Size</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Rate</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Stock Qty.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Damage Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Qty</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Balance Qty.</TableCell>
                                                        <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' className='tbl-row'>Total Qty.</TableCell>
                                                    </TableRow>
                                                    {
                                                        packData.map((item, index) => (
                                                            <TableRow key={index}>

                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={selectedRows.includes(index)}
                                                                        onChange={() => handleSelectChange(index)}
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' >{index + 1}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' >{item.barcode}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' >{item.order_no}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center' >{item.size}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.rate || '0'}  // Ensure value is either the number or an empty string
                                                                        name="rate"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        onChange={(e) => handleQuantityChange(index, 'rate', e.target.value)}  // Handle rate change
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.stkqty}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>{item.dqty}</TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.qty || '0'}  // Ensure value is either the number or an empty string
                                                                        name="qty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        max={item.stkqty}
                                                                        onChange={(e) => handleQuantityChange(index, 'qty', e.target.value)}  // Handle qty change
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.balqty || '0'}  // Show balance qty
                                                                        name="balqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    />
                                                                </TableCell>
                                                                <TableCell sx={{ p: 0.4, border: '1px solid #000' }} align='center'>
                                                                    <input
                                                                        type="text"
                                                                        value={item.totalqty || '0'}  // Show total qty
                                                                        name="totalqty"
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                        readOnly
                                                                    />
                                                                </TableCell>
                                                            </TableRow>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </>
                                }

                                {/* GST start here */}

                                {packData?.length > 0 &&
                                    <>

                                        <RadioComponent
                                            label='GST'
                                            name='gst_type'
                                            value={formData.gst_type}
                                            options={options_gst}
                                            onChange={handleRadioChange}
                                            isDesktop={true}
                                        />

                                        {formData.gst_type === 'yes' ?

                                            <>
                                                {/* {gstField?.map((field) => (
                                                    <DateInputComponent2
                                                        key={field.name}
                                                        formData={formData}
                                                        handleDateChange={handleDateChange}
                                                        handleInputChange={handleInputChange}
                                                        styled={styled}
                                                        inputStyles={inputStyles}
                                                        isDesktop={isDesktop}
                                                        field={field}
                                                        handleInputComplete={handleInputComplete}
                                                    />
                                                ))} */}

                                                {
                                                    dropdownGST?.map((drop) => (
                                                        <Dropdown
                                                            key={drop.label}
                                                            label={drop.label}
                                                            id={drop.id}
                                                            options={drop.options}
                                                            value={drop.value}
                                                            onChange={drop.onChange}
                                                            isDesktop={isDesktop}
                                                            getOptionLabel={drop.getOptionLabel}
                                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                                        />
                                                    ))
                                                }
                                            </>
                                            : (
                                                <Grid item xs={12} md={6}>
                                                </Grid>
                                            )
                                        }

                                        {fields2?.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))}


                                        <Grid item xs={12} md={6}>
                                            <Grid container alignItems="center" spacing={1}>
                                                <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                    <InputLabel htmlFor="discnt_amt">Discount Amount:</InputLabel>
                                                    <RadioGroup row name="discnt_type" value={formData.discnt_type} onChange={handleRadioChange}>
                                                        {opts_discnt_amt.map((option) => (
                                                            <FormControlLabel
                                                                key={option.value}
                                                                value={option.value}
                                                                control={<Radio />}
                                                                label={option.label}
                                                            />
                                                        ))}
                                                        {/* <input type="text" name='discnt_val' value={formData.discnt_val} onChange={handleInputChange}
                                                    style={{ width: '50px', height: '25px', paddingLeft: '5px', marginTop: '1px', color: 'red', fontSize: '15px' }} /> */}
                                                    </RadioGroup>
                                                </Grid>
                                                <Grid item xs>
                                                    <FormControl fullWidth style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}>
                                                        <TextField
                                                            id="discnt_val"
                                                            name="discnt_val"
                                                            value={formData.discnt_val}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.inputs }}
                                                            sx={inputNumbersmall}
                                                        />
                                                        <TextField
                                                            id="discnt_amt"
                                                            name="discnt_amt"
                                                            value={formData.discnt_amt}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: true }}
                                                            sx={inputStyle11}
                                                        />
                                                    </FormControl>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {fields21?.map((field) => (
                                            <DateInputComponent2
                                                key={field.name}
                                                formData={formData}
                                                handleDateChange={handleDateChange}
                                                handleInputChange={handleInputChange}
                                                styled={styled}
                                                inputStyles={inputStyles}
                                                isDesktop={isDesktop}
                                                field={field}
                                                handleInputComplete={handleInputComplete}
                                            />
                                        ))}

                                        <Grid item xs={12} md={6}>

                                        </Grid>

                                        {formData.gst_type === 'yes' &&
                                            <>
                                                {
                                                    [
                                                        { label: 'IGST', name: 'igst', type: 'readOnly' },

                                                    ].map((field) => (
                                                        <DateInputComponent
                                                            key={field.name}
                                                            formData={formData}
                                                            handleDateChange={handleDateChange}
                                                            handleInputChange={handleInputChange}
                                                            styled={styled}
                                                            inputStyles={inputStyles}
                                                            isDesktop={isDesktop}
                                                            field={field}
                                                        />
                                                    ))
                                                }

                                                <Grid item xs={12} md={6}>

                                                </Grid>

                                                {
                                                    [
                                                        { label: 'CGST', name: 'cgst', type: 'readOnly' },
                                                    ].map((field) => (
                                                        <DateInputComponent
                                                            key={field.name}
                                                            formData={formData}
                                                            handleDateChange={handleDateChange}
                                                            handleInputChange={handleInputChange}
                                                            styled={styled}
                                                            inputStyles={inputStyles}
                                                            isDesktop={isDesktop}
                                                            field={field}
                                                        />
                                                    ))
                                                }
                                                <Grid item xs={12} md={6}>

                                                </Grid>

                                                {
                                                    [
                                                        { label: 'SGST', name: 'sgst', type: 'readOnly' },
                                                        { label: 'Grand Total', name: 'netamt', type: 'readOnly' }
                                                    ].map((field) => (
                                                        <DateInputComponent
                                                            key={field.name}
                                                            formData={formData}
                                                            handleDateChange={handleDateChange}
                                                            handleInputChange={handleInputChange}
                                                            styled={styled}
                                                            inputStyles={inputStyles}
                                                            isDesktop={isDesktop}
                                                            field={field}
                                                        />
                                                    ))
                                                }
                                            </>

                                        }
                                    </>
                                }

                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true || packData?.length === 0}>
                                        {
                                            loading === true ?
                                                <><CircularProgress size="20px" /> wait...</> :
                                                "Submit"
                                        }
                                    </Button>
                                </Grid>

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        </>
    );
}

export default PackingEntry;
